/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSiteNameRequestDto
 */
export interface UpdateSiteNameRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSiteNameRequestDto
     */
    customerProvidedOptionalSiteName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSiteNameRequestDto
     */
    $type?: UpdateSiteNameRequestDtoTypeEnum;
}


/**
 * @export
 */
export const UpdateSiteNameRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedInstallDtoUpdateSiteNameRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Install.Dto.UpdateSiteNameRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UpdateSiteNameRequestDtoTypeEnum = typeof UpdateSiteNameRequestDtoTypeEnum[keyof typeof UpdateSiteNameRequestDtoTypeEnum];


/**
 * Check if a given object implements the UpdateSiteNameRequestDto interface.
 */
export function instanceOfUpdateSiteNameRequestDto(value?: unknown): value is UpdateSiteNameRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UpdateSiteNameRequestDtoTypeEnum)[0];
}

export function UpdateSiteNameRequestDtoFromJSON(json: any): UpdateSiteNameRequestDto {
    return UpdateSiteNameRequestDtoFromJSONTyped(json, false);
}

export function UpdateSiteNameRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSiteNameRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customerProvidedOptionalSiteName': json['customerProvidedOptionalSiteName'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function UpdateSiteNameRequestDtoToJSON(value?: UpdateSiteNameRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'customerProvidedOptionalSiteName': value.customerProvidedOptionalSiteName,
        '$type': value.$type,
    });
}

